// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ic4k","question":"styles_question__3cFJV","description":"styles_description__AWUVJ"};